import { ListItemClassKey } from '@material-ui/core/ListItem';
import { Theme } from '@material-ui/core/styles';

const MuiListItem = (theme: Theme): Partial<Record<ListItemClassKey, unknown>> => ({
    root: {
        '&.MuiListItem-button:hover': {
            color: theme.palette.primary.main,
        },
    },
});

export default MuiListItem;
